import { render, staticRenderFns } from "./SportMembershipsContainer.vue?vue&type=template&id=61c97b02&scoped=true"
import script from "./SportMembershipsContainer.vue?vue&type=script&lang=js"
export * from "./SportMembershipsContainer.vue?vue&type=script&lang=js"
import style0 from "./SportMembershipsContainer.vue?vue&type=style&index=0&id=61c97b02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c97b02",
  null
  
)

export default component.exports